// @logto/client экспортирует BaseClient, требующий ClientAdapter (storage/navigate/requester).
// @logto/browser — обёртка для SPA: в конструкторе сам подставляет localStorage, window.location.assign
// и fetch как requester. Наш модуль-уровневый инстанс использует именно его.
import LogtoBrowserClient from '@logto/browser'
import { UserScope } from '@logto/client'
import { BASE_URL, LOGTO_APP_ID, LOGTO_ENDPOINT } from '@/environment/environment'
import { installTokenTrace } from '@/utils/tokenTrace'

// Login, callback and API requests share one SDK client and token cache.
const logtoConfig = {
  endpoint: LOGTO_ENDPOINT,
  appId: LOGTO_APP_ID,
  resources: [BASE_URL],
  scopes: [
    UserScope.Email,
    UserScope.Phone,
    UserScope.CustomData,
    UserScope.Identities,
    UserScope.Organizations,
    UserScope.OrganizationRoles,
    UserScope.Roles,
  ],
}

// Если env-переменные не заданы — клиент null, приложение без Logto работать не будет.
export const logtoClient: LogtoBrowserClient | null
  = LOGTO_ENDPOINT && LOGTO_APP_ID ? new LogtoBrowserClient(logtoConfig) : null

if (logtoClient)
  installTokenTrace(logtoClient)

export default function () {
  if (!LOGTO_ENDPOINT || !LOGTO_APP_ID) {
    console.warn('[Logto] Missing VITE_LOGTO_ENDPOINT or VITE_LOGTO_APP_ID, SSO disabled')

    return
  }

}
